var svgNamespace = 'http://www.w3.org/2000/svg';
var extractSymbol = function (spriteSvg, symbolId) {
    var symbol = spriteSvg.querySelector('#' + CSS.escape(symbolId));
    if ((symbol === null || symbol === void 0 ? void 0 : symbol.tagName.toLowerCase()) !== 'symbol') {
        return null;
    }
    var svg = document.createElementNS(svgNamespace, 'svg');
    var attrs = symbol.attributes;
    for (var i = 0, len = attrs.length; i < len; i++) {
        var attr = attrs[i];
        if (attr.name !== 'id') {
            svg.setAttribute(attr.name, attr.value);
        }
    }
    var children = symbol.childNodes;
    for (var i = 0, len = children.length; i < len; i++) {
        svg.appendChild(children[i].cloneNode(true));
    }
    return svg;
};
export default extractSymbol;
//# sourceMappingURL=extract-symbol.js.map